import type { ReactNode } from "react";

import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type DetailRowProps = {
  icon: ReactNode;
  label: string;
  value: string;
};

export const DetailRow = ({ icon, label, value }: DetailRowProps) => (
  <HStack
    alignItems="center"
    justifyContent="space-between"
    gap={3}
    paddingVertical={2}
  >
    <HStack alignItems="center" gap={3} flex={1}>
      <Box
        backgroundColor="surface-main-primary-subtlest"
        height={24}
        width={24}
        justifyContent="center"
        alignItems="center"
        borderRadius="2"
      >
        {icon}
      </Box>
      <Text variant="mainBaseSemiBold" color="text-primary">
        {label}
      </Text>
    </HStack>
    <Text variant="mainBaseSemiBold" color="text-primary" textAlign="right">
      {value}
    </Text>
  </HStack>
);
